import React, { useState, useEffect, useRef } from 'react';
import { langCheck, getCustomTheme, getWatermarkSettings } from "Pub/js/utils.js";
import SubjectSetting from '../Customize/SubjectSetting';
import { getStore } from "Pub/js/storageUtils";
import { changeBgState } from "Store/appStore/action";
import { connect } from "react-redux";
import Notice from "Components/Notice";
import subjectDefaultData from "Pub/js/subjectDefaultData";
import PermissionArea from './components/PermissionArea';
import Ajax from "Pub/js/ajax";
import { getBackgroundObject, requestStyleSettings, getWaterMarkObject } from './common';
const {
    defaultBackgroundObject,
    defaultLight,
} = subjectDefaultData;

const GroupStyleSetting = props => {
    const title = langCheck("0000PUB-000393"); /**多语设置：企业风格设置-集团 */
    const defaultObj = {
        backgroundObject: defaultBackgroundObject,
        data: {
            // color: "#F1F1F1",
            color: defaultLight,
            icon: "",
            customColors: []
        },
        groupChecked: true,
        userChecked: true,
    };
    const [companyStyleSettingObj, setCompanyStyleSettingObj] = useState(defaultObj);
    const subjectRef = useRef(null);
    const infoData = getStore("STOREFORINFODATA", true);
    const currentPkGroup = infoData && infoData.groupVOs && infoData.groupVOs.filter((item => item.is_selected))[0].pk_group;
    const pk_group = companyStyleSettingObj && companyStyleSettingObj.foolValue && companyStyleSettingObj.foolValue.value || currentPkGroup;
    // 首次加载接口
    useEffect(() => {
        const foolValue = {};
        if (infoData) {
            const groupData = infoData.groupVOs.filter((item => item.is_selected))[0];
            foolValue.display = groupData.groupName;
            foolValue.value = groupData.pk_group;
        }
        ajaxQuerycorporatestyle(pk_group, foolValue);
    }, []);
    // 传给子组件方法
    const getGroupData = (pk_group, foolValue) => {
        ajaxQuerycorporatestyle(pk_group, foolValue);
    };
    // 获取企业风格设置请求接口
    const ajaxQuerycorporatestyle = (pk_group, foolValue) => {
        Ajax({
            url: "/nccloud/workbench/corporatestyle/querycorporatestyle.do",
            data: {
                styletype: '1',
                pk_group: pk_group,
            },
            noNeedShowError: true,
            success: async ({ data: { data, success } }) => {
                if (success && Object.keys(data).length) {
                    data.customColors = await getCustomTheme({
                        pk_group,
                        styletype: '1',
                    });
                    let watermarkObject = await getWatermarkSettings({ styletype: '1', pk_group: pk_group });
                    watermarkObject = getWaterMarkObject(watermarkObject);

                    if (data.isDefault || data.customtheme_del) {
                        if (data.customtheme_del) {
                            Notice({
                                status: "warning",
                                msg: langCheck("0000PUB-000487"), /*当前主题色已删除，恢复默认主题*/
                            });
                        }
                        const { groupmodify = true, usermodify = true } = data;
                        // 走默认样式
                        const obj = JSON.parse(JSON.stringify(defaultObj));
                        obj.data = { ...obj.data, ...data };
                        
                        setStyleSettings({
                            foolValue,
                            ...obj, 
                            groupChecked: groupmodify, 
                            userChecked: usermodify,
                            watermarkSetting: watermarkObject.watermarkSetting,
                        });
                    } else {
                        let { groupmodify, usermodify } = data;
                        const backgroundObject = getBackgroundObject(data);
                        const obj = { 
                            groupChecked: groupmodify, 
                            userChecked: usermodify, 
                            data: data, 
                            backgroundObject, 
                            foolValue,
                            watermarkSetting: watermarkObject.watermarkSetting,
                        };
                        setStyleSettings(obj);
                    }
                }
            },
            error: () => {
                // 走默认样式
                setStyleSettings({ ...defaultObj });
            },
        });
    };

    const setStyleSettings = (settings) => {
        setCompanyStyleSettingObj(settings);
        subjectRef.current.setStyleSettings(settings.data, settings.watermarkSetting);
    }

    // 企业风格设置接口
    const companyStyleSettingFn = ({ usermodify, styleSettings }) => {
        const { data } = companyStyleSettingObj;
        const { pk_group, ts, customColors } = data;
        if (!pk_group) {
            Notice({
                status: "warning",
                msg: langCheck('0000PUB-000417'), /* 国际化处理： 请选择集团参照*/
            });
            return;
        }
        const { changeBgState } = props;
        let { groupChecked, userChecked } = companyStyleSettingObj;
        let obj = {
            styletype: '1', //企业风格类型 0-全局  1-集团
            pk_group, //所属集团
            groupmodify: groupChecked, //是否允许集团修改
            usermodify: userChecked, //是否允许用户修改
            ts, //解决并发问题
            ...styleSettings
        };
        requestStyleSettings({ obj, usermodify, changeBgState, currentPkGroup, pk_group }).then(([styleData, watermarkData]) => {
            const newCompanyStyleSettingObj = JSON.parse(JSON.stringify(companyStyleSettingObj));
            newCompanyStyleSettingObj.data = { ...styleData, customColors };
            let watermarkObject = getWaterMarkObject(watermarkData);
            newCompanyStyleSettingObj.watermarkSetting = watermarkObject.watermarkSetting;
            setStyleSettings(newCompanyStyleSettingObj);
        });
    };
    return (
        <SubjectSetting
            title={title}
            permissionArea={<PermissionArea isGlobal={false} setCompanyStyleSettingObj={setCompanyStyleSettingObj} companyStyleSettingObj={companyStyleSettingObj} />}
            companyStyleSettingObj={companyStyleSettingObj}
            styleType='1'
            companyStyleSettingFn={companyStyleSettingFn}
            setCompanyStyleSettingObj={setCompanyStyleSettingObj}
            isGlobal={false}
            styleSettingName="group"
            getGroupData={getGroupData}
            subjectRef={ref => subjectRef.current = ref}
            hideBackBtn={props.hideBackBtn}
        />
    );
};
export default connect(
    () => { },
    { changeBgState },
)(GroupStyleSetting);